import Main from "_c/main"

export default {
    path: "/",
    name: "",
    component:Main,
    children:[
        {
            path:"/401",
            name:"401",
            component: () => import('@/view/errorpage/401page.vue'),
            meta:{
                parent:true,
                name:"无访问权限"
            },
        },
        {
            path:"/404",
            name:"404",
            component: () => import('@/view/errorpage/404page.vue'),
            meta:{
                parent:true,
                name:"找不到页面"
            },
        }
    ]
    
}


// WEBPACK FOOTER //
// ./src/router/modules/other.js